import { Injectable } from '@angular/core';
import { StorageLoader } from './storageLoader';
import { environment } from 'src/environments/environment';

const ENVIRONMENT = environment.ENVIRONMENT;

@Injectable({
  providedIn: 'root',
})
export class HeaderLoader {
  constructor(private storageLoader: StorageLoader) {}

  basic() {
    return {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Environment: ENVIRONMENT,
      },
      observe: 'response' as const,
    };
  }

  async auth() {
    const token = await this.storageLoader.getToken();

    return {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        Environment: ENVIRONMENT,
      },
      observe: 'response' as const,
    };
  }

  async authRefresh() {
    const token = await this.storageLoader.getRefreshToken();

    return {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        Environment: ENVIRONMENT,
      },
      observe: 'response' as const,
    };
  }

  async authMultiPart() {
    const token = await this.storageLoader.getToken();

    return {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        Environment: ENVIRONMENT,
      },
      observe: 'response' as const,
    };
  }
}
